
type HighlightCardUnactiveProps = {
  title : String;
  subtitle? : string
}

const HightlightCardUnactive = ({ title, subtitle } : HighlightCardUnactiveProps) => {
  return (
    <div className="highlight-unactive">
      <h3 className="title">{title}</h3>
    </div>
  )
}

export default HightlightCardUnactive